import { render, staticRenderFns } from "./wholesale.vue?vue&type=template&id=83678b90"
import script from "./wholesale.vue?vue&type=script&lang=js"
export * from "./wholesale.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./wholesale.vue?vue&type=style&index=0&id=83678b90&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "23d41284"
  
)

export default component.exports